exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".checkbox-style {\n  width: 18px;\n  height: 18px;\n  cursor: pointer; }\n", ""]);

